import { BASE_CLASS_PREFIX } from '../base/constants';



const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-lottie`,
};

const strings = {

};

const numbers = {

};

export { cssClasses, strings, numbers };
